import React from 'react';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const ProjectSummaryOnboardingBase = lazyAfterPaint(
	() =>
		import(
			/* webpackChunkName: "async-servicedesk-queues-agent-view-project-summary-onboarding" */ './index.tsx'
		),
	{ ssr: false },
);

type ProjectSummaryOnboardingAsyncProps = {
	projectKey: string;
};

const ProjectSummaryOnboardingAsync = ({ projectKey }: ProjectSummaryOnboardingAsyncProps) => (
	<Placeholder name="async-project-summary-onboarding" fallback={null}>
		<ProjectSummaryOnboardingBase projectKey={projectKey} />
	</Placeholder>
);

export default ProjectSummaryOnboardingAsync;
